<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div>
        <div class="second img-right">
          <img :src="imageSrc(item.num)" alt="">
          <div class="desc-div">
            <p class="desc">{{item.desc}}</p>
          </div>
        </div>
        <ul>
          <li>
            <div><p>활동 시기 :&nbsp;</p></div>
            <div><p>{{item.date}}</p></div>
          </li>
          <li>
            <div><p>기부처 :&nbsp;</p></div>
            <div><p>{{item.place}}</p></div>
          </li>
          <li class="performance" v-if="item.performance">
            <div class="li-left"><p>활동 실적 :&nbsp;</p></div>
            <div class="third">
              <p v-for="(children, i) in item.performance" :key="i">
                - {{children.item}}
              </p>
            </div>
          </li>
          <li>
            <div><p>관련기사 :&nbsp;</p></div>
            <div>
              <p>
                <a :href="item.article" target="_blank">{{item.article}}</a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsrHopeGoal',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 3,
          title: '감사나눔 희망골',
          desc: '"감사나눔 희망골"은 전남드래곤즈가 2012년 말부터 홈경기에서 득점을 할 때마다 전남드래곤즈가 쌀 100kg을 적립, 광양제철소도 Matching Grant 방식으로 참여하여 적립하고 시즌 종료 후 광양시 사랑나눔복지재단에 기부하여 지역의 어려운 이웃들을 돕는 프로그램입니다. 축구를 통해 희망과 나눔의 의미를 부여하고 지역사회 소외계층을 위해 감사나눔을 실천함으로써 사랑받는 구단과 후원사 이미지를 구현하는 활동입니다.',
          date: '매년 K리그2 시즌 중(기부:12월)',
          place: '관내 복지관 및 재단',
          performance: [
            { item: "누적 기부액 : 총 68,600kg" },
            { item: "2025시즌 홈경기 20경기 36득점으로 총 7,200kg 기부" },
            { item: "2024시즌 5,600kg" },
            { item: "2023시즌 6,400kg" },
            { item: "2022시즌 4,400kg" },
            { item: "2021시즌 3,800kg" },
            { item: "2020시즌 3,400kg" },
            { item: "2019시즌 4,600kg" },
            { item: "2018시즌 5,200kg" },
            { item: "2017시즌 7,000kg" },
            { item: "2016시즌 4,800kg" },
            { item: "2015시즌 4,800kg" },
            { item: "2014시즌 6,200kg" },
            { item: "2013시즌 4,200kg" },
            { item: "2012시즌 1,000kg (2012.10~)" },
          ],
          article: 'https://biz.heraldcorp.com/article/10648444?ref=naver'
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/program_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

.program-page .item-div ul li:nth-child(3)::before {
  display: none;
}
.performance .li-left p::before {
  content: "";
  display: inline-block;
  width: 2px;
  height: 2px;
  vertical-align: middle;
  margin: 0 5px 0 0;
  background: #777777;
}
.program-page .item-div ul .performance .third {
  padding-left: 7px;
}
@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
